const SHIPMENT_TYPES = [
  {
    label: 'Shorthaul',
    value: 'shorthaul',
  },
  {
    label: 'Longhaul',
    value: 'longhaul',
  },
  {
    label: 'Dayrate',
    value: 'dayrate',
  },
];
export const RAIL = 'rail';
export const DRAYAGE = 'drayage';
export const INTERMODAL_TYPES = [DRAYAGE, RAIL];

export default SHIPMENT_TYPES;
